import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {ActivityLogEntryList} from '../activity_log/ActivityLogEntryList';

export function ActivityLogPreviewBox({clientId, entries, loading, onAddNote}) {
    const {t} = useTranslation();

    const isEmpty = !loading && (!entries || entries.length === 0);
    // Una sola ruta para los dos marcos: en la 2.1 es la pestaña Historial (card 2BZI0Us8) y en
    // el clásico la Bitácora standalone. Hasta el 24/09 la 2.1 mandaba a la bandeja del Recorrido.
    const seeAllTo = `/client/${clientId}/activity-log`;

    return (
        <div className="box activity-log-preview-box">
            <div className="activity-log-preview-header">
                <h3 className="activity-log-preview-title">{t('control_central.activity_log_title')}</h3>
                <button className="activity-log-preview-add-btn" onClick={onAddNote}>
                    <FaIcon iconName="plus"/>
                    {t('control_central.activity_log_add_note')}
                </button>
            </div>

            {isEmpty ? (
                <div className="cc-empty-state">
                    <FaIcon iconName="history"/>
                    <p>{t('control_central.activity_log_empty')}</p>
                    <button className="btn -alt -small" onClick={onAddNote}>
                        <FaIcon iconName="plus"/>
                        {t('control_central.activity_log_empty_cta')}
                    </button>
                </div>
            ) : (
                <ActivityLogEntryList entries={entries} loading={loading} clientId={clientId}/>
            )}

            <div className="activity-log-preview-footer">
                <Link to={seeAllTo}>
                    {t('control_central.activity_log_see_all')} &rarr;
                </Link>
            </div>
        </div>
    );
}
